(function () {
  'use strict';

  var DISCOUNT_CODE = 'WELKOM15';
  var STORAGE_KEY = 'dhs_welcome_discount';
  var CHECKOUT_KEY = 'dhs_welcome_checkout_visited';
  var REJECTED_KEY = 'dhs_welcome_discount_rejected';
  var MANUAL_REMOVAL_KEY = 'dhs_welcome_discount_manually_removed';
  var ACTIVE_CLASS = 'welcome-discount-active';
  var LIFETIME_DAYS = 30;
  var stateRevision = 0;
  var lastCartEmpty = null;
  var removingWelcomeCode = false;
  var restoringWelcomeCode = false;
  var checkoutIntent = false;
  var cleanupPromise = null;
  var syncTimer = null;
  var rejection = null;
  var noticeTimer = null;
  var noticeCloseTimer = null;
  var noticeHideTimer = null;

  function wasManuallyRemoved() {
    if (removingWelcomeCode) return true;
    var removedAt = 0;
    try { removedAt = Number(localStorage.getItem(MANUAL_REMOVAL_KEY)); } catch (error) {}
    if (!removedAt) {
      try { removedAt = Number(sessionStorage.getItem(MANUAL_REMOVAL_KEY)); } catch (error) {}
    }
    return removedAt > Date.now() - LIFETIME_DAYS * 86400000;
  }

  function rememberManualRemoval() {
    removingWelcomeCode = true;
    try { localStorage.setItem(MANUAL_REMOVAL_KEY, String(Date.now())); } catch (error) {}
    try { sessionStorage.setItem(MANUAL_REMOVAL_KEY, String(Date.now())); } catch (error) {}
    clearCheckoutHistory();
  }

  function clearManualRemoval() {
    removingWelcomeCode = false;
    try { localStorage.removeItem(MANUAL_REMOVAL_KEY); } catch (error) {}
    try { sessionStorage.removeItem(MANUAL_REMOVAL_KEY); } catch (error) {}
  }

  function getRejection() {
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(REJECTED_KEY) || 'null'); } catch (error) {}
    if (!stored) {
      try { stored = JSON.parse(sessionStorage.getItem(REJECTED_KEY) || 'null'); } catch (error) {}
    }
    stored = stored || rejection;
    /* De vorige versie kon zelf verwijderen als afwijzing opslaan. Vertrouw
       zo'n oude blokkade pas weer na actuele validatie door Shopify. */
    if (stored && stored.source !== 'checkout') {
      clearRejection();
      return null;
    }
    if (!stored || stored.code !== DISCOUNT_CODE || stored.expiresAt <= Date.now()) return null;
    return stored;
  }

  function clearRejection() {
    rejection = null;
    try { localStorage.removeItem(REJECTED_KEY); } catch (error) {}
    try { sessionStorage.removeItem(REJECTED_KEY); } catch (error) {}
  }

  function rememberRejection(notify) {
    var existing = getRejection();
    rejection = existing || { code: DISCOUNT_CODE, source: 'checkout', expiresAt: Date.now() + LIFETIME_DAYS * 86400000 };
    try { localStorage.setItem(REJECTED_KEY, JSON.stringify(rejection)); } catch (error) {}
    try { sessionStorage.setItem(REJECTED_KEY, JSON.stringify(rejection)); } catch (error) {}
    /* Een afwijzing mag de oorspronkelijke aanbieding niet opnieuw openen. */
    try { localStorage.setItem('dhs_welcome_popup_discount_selected', String(Date.now())); } catch (error) {}
    document.dispatchEvent(new CustomEvent('welcome-discount:rejected', { detail: { code: DISCOUNT_CODE } }));
    /* Deze status verplicht een nieuwe controle, maar blokkeert geen klant.
       Alleen een bewuste activatie met actuele afwijzing toont de melding. */
    if (notify) showUnavailableNotice();
  }

  function showUnavailableNotice() {
    var notice = document.querySelector('[data-welcome-discount-unavailable]');
    if (!notice || (window.Shopify && window.Shopify.designMode)) return;
    window.clearTimeout(noticeTimer);
    var popup = document.querySelector('dhs-welcome-popup');
    var cookiePrompt = popup && typeof popup.cookieBannerVisible === 'function' && popup.cookieBannerVisible();
    if (cookiePrompt) {
      noticeTimer = window.setTimeout(showUnavailableNotice, 300);
      return;
    }
    window.clearTimeout(noticeCloseTimer);
    window.clearTimeout(noticeHideTimer);
    notice.hidden = false;
    /* Een handmatige popover blijft ook boven een quick-viewdialoog zichtbaar
       zonder focus te verplaatsen of het winkelen te onderbreken. */
    if (typeof notice.showPopover === 'function' && !notice.matches(':popover-open')) notice.showPopover();
    var message = notice.querySelector('[data-welcome-discount-unavailable-message]');
    /* Herhaal de aankondiging voor schermlezers ook bij een volgende klik. */
    if (message) {
      var text = message.dataset.message;
      message.textContent = '';
      window.requestAnimationFrame(function () { message.textContent = text; });
    }
    window.requestAnimationFrame(function () {
      if (!notice.hidden) notice.classList.add('is-visible');
    });
    noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000);
  }

  function closeUnavailableNotice() {
    window.clearTimeout(noticeTimer);
    window.clearTimeout(noticeHideTimer);
    var notice = document.querySelector('[data-welcome-discount-unavailable]');
    if (!notice || notice.hidden) return;
    notice.classList.remove('is-visible');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.clearTimeout(noticeCloseTimer);
    noticeCloseTimer = window.setTimeout(function () {
      if (typeof notice.hidePopover === 'function') notice.hidePopover();
      notice.hidden = true;
    }, reducedMotion ? 0 : 240);
  }

  function hasVisitedCheckout() {
    try { if (sessionStorage.getItem(CHECKOUT_KEY) === 'true') return true; } catch (error) {}
    var saved = getSavedDiscount();
    return Boolean(saved && saved.checkoutVisited);
  }

  function rememberCheckoutVisit() {
    try { sessionStorage.setItem(CHECKOUT_KEY, 'true'); } catch (error) {}
    var saved = getSavedDiscount();
    if (saved) {
      saved.checkoutVisited = true;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(saved)); } catch (error) {}
    }
  }

  function clearCheckoutHistory() {
    checkoutIntent = false;
    try { sessionStorage.removeItem(CHECKOUT_KEY); } catch (error) {}
  }

  function getSavedDiscount() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || saved.code !== DISCOUNT_CODE || saved.expiresAt <= Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return saved;
    } catch (error) {
      return null;
    }
  }

  function saveDiscount() {
    var expiresAt = Date.now() + LIFETIME_DAYS * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        active: true,
        code: DISCOUNT_CODE,
        expiresAt: expiresAt
      }));
    } catch (error) {
      /* De winkelwagen blijft de bron van waarheid als opslag geblokkeerd is. */
    }
  }

  function discountUrl() {
    var redirectPath = window.location.pathname + window.location.search;
    return '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=' + encodeURIComponent(redirectPath);
  }

  function applyDiscountToShopify() {
    if (cleanupPromise) {
      return cleanupPromise.then(function () { return applyDiscountToShopify(); });
    }
    var requiresValidation = hasVisitedCheckout() || Boolean(getRejection());
    var applyRevision = stateRevision;
    return fetch(discountUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Kortingscode kon niet worden geactiveerd.');
      if (applyRevision !== stateRevision) return false;
      if (requiresValidation) {
        /* Ook een bezoek uit de vorige scriptversie mag niet via een knopklik
           terugvallen op alleen de geslaagde kortingsredirect. */
        return readCart().then(function (cart) {
          if (applyRevision !== stateRevision) return false;
          if (!welcomeCodeRejected(cart) && cartHasAppliedWelcomeDiscount(cart) === true) {
            clearRejection();
            closeUnavailableNotice();
            return response;
          }
          resetActive();
          /* Ontbrekende korting en een lege winkelwagen zeggen niets over
             het recht op welkomstkorting. Alleen expliciete afwijzing telt. */
          if (welcomeCodeRejected(cart)) {
            var cartHasItems = Array.isArray(cart.items) ? cart.items.length > 0 : cart.item_count > 0;
            rememberRejection(cartHasItems);
            removeRejectedWelcomeCode(cart);
          }
          return false;
        });
      }
      return response;
    });
  }

  function setActive() {
    if (wasManuallyRemoved()) return;
    document.documentElement.classList.add(ACTIVE_CLASS);
    document.dispatchEvent(new CustomEvent('welcome-discount:activated', {
      detail: { code: DISCOUNT_CODE, percentage: 15 }
    }));
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: false }
    }));
  }

  function resetActive() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}

    document.documentElement.classList.remove(ACTIVE_CLASS);
    document.querySelectorAll('[data-welcome-discount-activate]').forEach(function (button) {
      var label = button.querySelector('[data-welcome-discount-button-text]');
      if (label) label.textContent = button.getAttribute('data-welcome-discount-original-text') || label.textContent || '15% korting op je eerste bestelling';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    document.dispatchEvent(new CustomEvent('welcome-discount:deactivated', {
      detail: { code: DISCOUNT_CODE }
    }));
  }

  function isWelcomeCode(code) {
    return String(code || '').trim().toUpperCase() === DISCOUNT_CODE;
  }

  function cartContainsWelcomeCode(cart) {
    if (!cart) return null;

    /* De ingevoerde codes zijn leidend, ook wanneer er geen productkorting is. */
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(function (discount) {
        return typeof discount === 'string'
          ? isWelcomeCode(discount)
          : discount && isWelcomeCode(discount.code);
      });
    }

    if (Array.isArray(cart.cart_level_discount_applications)) {
      if (cart.cart_level_discount_applications.some(function (application) {
        return isWelcomeCode(application && (application.title || application.code));
      })) return true;
    }

    if (Array.isArray(cart.items)) {
      var welcomeAllocationFound = cart.items.some(function (item) {
        var allocations = item.discount_allocations || item.line_level_discount_allocations || [];
        return allocations.some(function (allocation) {
          var application = allocation.discount_application || allocation.application || {};
          return isWelcomeCode(application.title || application.code);
        });
      });
      if (welcomeAllocationFound) return true;
    }

    return Array.isArray(cart.items) || Array.isArray(cart.cart_level_discount_applications) ? false : null;
  }

  function cartHasOtherWinningProductCode(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      var allocations = item.discount_allocations || item.line_level_discount_allocations || [];
      return allocations.some(function (allocation) {
        var application = allocation.discount_application || allocation.application || {};
        var code = application.title || application.code;
        var isDiscountCode = application.type === 'discount_code' || application.type === 'code';
        return isDiscountCode && code && !isWelcomeCode(code);
      });
    });
  }

  function welcomeCodeRejected(cart) {
    return Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (discount) {
      return discount && isWelcomeCode(discount.code) && discount.applicable === false;
    });
  }

  function cartHasAppliedWelcomeDiscount(cart) {
    if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.some(function (application) {
      return application && isWelcomeCode(application.title || application.code) && Number(application.total_allocated_amount) > 0;
    })) return true;
    if (Array.isArray(cart.items)) {
      return cart.items.some(function (item) {
        return (item.line_level_discount_allocations || item.discount_allocations || []).some(function (allocation) {
          var application = allocation.discount_application || allocation.application || {};
          return isWelcomeCode(application.title || application.code) && Number(allocation.amount) > 0;
        });
      });
    }
    return Array.isArray(cart.cart_level_discount_applications) ? false : null;
  }

  function removeRejectedWelcomeCode(cart) {
    if (cleanupPromise) return;
    var codes = [];
    function keepCode(code) {
      if (code && !isWelcomeCode(code) && codes.indexOf(code) === -1) codes.push(code);
    }
    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        keepCode(typeof discount === 'string' ? discount : discount && discount.code);
      });
    } else {
      function keepApplication(application) {
        if (application && (application.type === 'discount_code' || application.type === 'code')) {
          keepCode(application.code || application.title);
        }
      }
      (cart.cart_level_discount_applications || []).forEach(keepApplication);
      (cart.items || []).forEach(function (item) {
        (item.discount_allocations || item.line_level_discount_allocations || []).forEach(function (allocation) {
          keepApplication(allocation.discount_application || allocation.application);
        });
      });
    }
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    cleanupPromise = fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('Kortingscode kon niet worden verwijderd.');
      refreshCartDrawer();
    }).catch(function () {
      /* De website blijft gedeactiveerd; een volgende controle probeert opnieuw. */
    }).then(function () { cleanupPromise = null; });
  }

  function syncDiscountFromCart(cart) {
    if (!cart) return;
    var savedDiscount = getSavedDiscount();
    var containsWelcomeCode = cartContainsWelcomeCode(cart);
    var cartEmpty = Array.isArray(cart.items) ? cart.items.length === 0 : cart.item_count === 0;
    var wasEmpty = lastCartEmpty === true;
    lastCartEmpty = cartEmpty;

    /* Zelf verwijderen is een keuze, geen afwijzing. Ook een nog lopende
       cart-aanvraag of een volgende pagina mag daar geen foutmelding van maken. */
    if (wasManuallyRemoved()) {
      stateRevision += 1;
      resetActive();
      return;
    }

    /* Een eerdere afwijzing verplicht controle; deze is nooit een blijvende
       uitspraak over de klant of het recht op een eerste-bestellingskorting. */
    if (getRejection()) {
      if (cartHasAppliedWelcomeDiscount(cart) === true && !welcomeCodeRejected(cart)) {
        clearRejection();
        closeUnavailableNotice();
      } else {
        stateRevision += 1;
        resetActive();
        if (welcomeCodeRejected(cart)) removeRejectedWelcomeCode(cart);
        return;
      }
    }

    /* Voor checkout mag de bezoeker de aanbieding kiezen. Na checkout is
       Shopify leidend, ook bij een lege winkelwagen of expliciete afwijzing. */
    if (hasVisitedCheckout() && (welcomeCodeRejected(cart) || containsWelcomeCode === false || cartHasAppliedWelcomeDiscount(cart) === false)) {
      var hadWelcomeDiscount = savedDiscount || document.documentElement.classList.contains(ACTIVE_CLASS) || containsWelcomeCode;
      stateRevision += 1;
      if (hadWelcomeDiscount && welcomeCodeRejected(cart)) rememberRejection(false);
      resetActive();
      if (hadWelcomeDiscount && welcomeCodeRejected(cart)) removeRejectedWelcomeCode(cart);
      return;
    }

    if (containsWelcomeCode === true) {
      if (cartHasOtherWinningProductCode(cart)) {
        resetActive();
        return;
      }

      if (!savedDiscount) saveDiscount();
      setActive();
      return;
    }

    if (containsWelcomeCode === false) {
      /* Een lege winkelwagen vergeet soms de code; bewaar de gekozen aanbieding. */
      if (cartEmpty && savedDiscount) {
        setActive();
        return;
      }

      /* Na een lege winkelwagen wordt de code eenmalig opnieuw bij Shopify gezet. */
      if (wasEmpty && savedDiscount && !restoringWelcomeCode) {
        var restoreRevision = stateRevision;
        restoringWelcomeCode = true;
        setActive();
        applyDiscountToShopify()
          .then(function () { if (restoreRevision === stateRevision) refreshCartDrawer(); })
          .catch(function () { if (restoreRevision === stateRevision) resetActive(); })
          .then(function () { restoringWelcomeCode = false; });
        return;
      }

      if (savedDiscount || document.documentElement.classList.contains(ACTIVE_CLASS)) resetActive();
    }
  }

  function activate(button) {
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    clearManualRemoval();
    stateRevision += 1;
    var revision = stateRevision;

    var text = button.querySelector('[data-welcome-discount-button-text]');
    var originalText = text ? text.textContent : '';
    button.setAttribute('data-welcome-discount-original-text', originalText);
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (text) text.textContent = 'Korting activeren…';

    applyDiscountToShopify()
      .then(function (response) {
        if (text) text.textContent = originalText;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (revision !== stateRevision || response === false || getRejection()) return;
        clearCheckoutHistory();
        saveDiscount();
        setActive();
        refreshCartDrawer();
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (text) text.textContent = 'Probeer opnieuw';
        window.setTimeout(function () {
          if (text) text.textContent = originalText;
        }, 2500);
      });
  }

  function readCart() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return fetch(root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Winkelwagen kon niet worden gelezen.');
        return response.json();
      });
  }

  function syncSavedDiscount() {
    var revision = ++stateRevision;
    readCart().then(function (cart) {
        if (revision === stateRevision) syncDiscountFromCart(cart);
      })
      .catch(function () {
        /* Zonder actuele winkelwagenstatus geen welkomstprijs claimen. */
        if (revision === stateRevision && document.documentElement.classList.contains(ACTIVE_CLASS)) resetActive();
      });
  }

  function scheduleCartSync() {
    if (!getSavedDiscount() && !hasVisitedCheckout() && !document.documentElement.classList.contains(ACTIVE_CLASS)) return;
    window.clearTimeout(syncTimer);
    var revision = stateRevision;
    syncTimer = window.setTimeout(function () {
      if (revision === stateRevision) syncSavedDiscount();
    }, 80);
  }

  document.addEventListener('click', function (event) {
    /* Hyper vervangt de drawer-header na cart:refresh zonder de sluitknop opnieuw te koppelen. */
    var drawerCloseButton = event.target.closest('cart-drawer .drawer__header button.drawer__close-btn[aria-controls]');
    if (drawerCloseButton) {
      var drawer = drawerCloseButton.closest('cart-drawer');
      /* De bestaande Hyper-handler heeft voorrang; herstel alleen een losgeraakte knop. */
      if (drawer && drawer.open) drawer.hide();
    }

    var removeButton = event.target.closest('button[is="cart-discount-remove"]');
    if (removeButton) {
      var discountItem = removeButton.closest('[data-discount-code]');
      if (discountItem && isWelcomeCode(discountItem.getAttribute('data-discount-code'))) {
        stateRevision += 1;
        rememberManualRemoval();
        resetActive();
        closeUnavailableNotice();
      }
    }

    var button = event.target.closest('[data-welcome-discount-activate]');
    if (!button) return;
    event.preventDefault();
    activate(button);
  });

  /*
   * Hyper verstuurt dit event na toevoegen/verwijderen van een kortingscode.
   * Daardoor verdwijnt de visuele 15%-prijs direct wanneer WELKOM15 uit de
   * winkelmand wordt verwijderd. Andere kortingscodes hebben geen invloed.
   */
  document.addEventListener('cart:updated', function (event) {
    stateRevision += 1;
    syncDiscountFromCart(event.detail && event.detail.cart);
  });

  document.addEventListener('submit', function (event) {
    if (event.submitter && event.submitter.name === 'checkout') {
      checkoutIntent = !event.defaultPrevented;
      /* Bewaar dit al bij de toegestane submit, niet pas bij pagehide.
         De minimum-bestelwaardecontrole blokkeert de eerste submit en
         verstuurt daarna opnieuw als afrekenen daadwerkelijk is toegestaan. */
      if (checkoutIntent) rememberCheckoutVisit();
    }
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    var url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && /\/(checkouts?)(\/|$)/.test(url.pathname)) {
      checkoutIntent = true;
      rememberCheckoutVisit();
    }
  });

  /* Een gewone link terug vanuit checkout kan ook een nieuwe pagina laden. */
  try {
    var referrer = document.referrer && new URL(document.referrer);
    if (referrer && referrer.origin === window.location.origin && /\/(checkouts?)(\/|$)/.test(referrer.pathname)) {
      rememberCheckoutVisit();
      document.documentElement.classList.remove(ACTIVE_CLASS);
    }
  } catch (error) {}

  window.addEventListener('pagehide', function () {
    window.clearTimeout(syncTimer);
    if (!checkoutIntent) return;
    rememberCheckoutVisit();
    /* Ook de pagina die de browser bewaart mag geen oude korting tonen. */
    document.documentElement.classList.remove(ACTIVE_CLASS);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted && !hasVisitedCheckout()) return;
    if (hasVisitedCheckout()) document.documentElement.classList.remove(ACTIVE_CLASS);
    scheduleCartSync();
  });

  window.addEventListener('focus', scheduleCartSync);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleCartSync();
  });
  document.addEventListener('drawer:handleAfterShow', function (event) {
    if (event.target.matches('cart-drawer')) scheduleCartSync();
  });

  var unavailableNotice = document.querySelector('[data-welcome-discount-unavailable]');
  if (unavailableNotice) {
    unavailableNotice.addEventListener('click', function (event) {
      if (event.target.closest('[data-welcome-discount-unavailable-close]')) closeUnavailableNotice();
    });
    unavailableNotice.addEventListener('mouseenter', function () { window.clearTimeout(noticeHideTimer); });
    unavailableNotice.addEventListener('focusin', function () { window.clearTimeout(noticeHideTimer); });
    unavailableNotice.addEventListener('mouseleave', function () { noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000); });
    unavailableNotice.addEventListener('focusout', function () { noticeHideTimer = window.setTimeout(closeUnavailableNotice, 6000); });
    unavailableNotice.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeUnavailableNotice(); });
  }
  window.addEventListener('storage', function (event) {
    if (event.key === REJECTED_KEY && getRejection()) {
      stateRevision += 1;
      resetActive();
    }
  });

  window.DHSWelcomeDiscount = {
    activate: function () {
      clearManualRemoval();
      stateRevision += 1;
      var revision = stateRevision;
      return applyDiscountToShopify().then(function (response) {
        if (revision !== stateRevision || response === false || getRejection()) return;
        clearCheckoutHistory();
        saveDiscount();
        setActive();
        refreshCartDrawer();
      });
    },
    resetDisplay: function () {
      resetActive();
    }
  };

  if (getRejection() || wasManuallyRemoved()) resetActive();
  syncSavedDiscount();
})();
